const number: number[] = [];
for (let i = 0; i <= 11; i++) {
  number.push(i);
}
const number_re: { code: string; value: string }[] = [];
for (let i = 0; i <= 11; i++) {
  number_re.push({ code: String(i), value: String(i) });
}
export const number0_11 = number_re;

const number2: number[][] = [];
for (let i = 0; i <= 10; i++) {
  number2.push([i, i]);
}
const number2_re: { code: string; value: string }[] = [];
for (let i = 0; i <= 10; i++) {
  number2_re.push({ code: String(i), value: String(i) });
}
export const number0_10 = number2_re;
